import { render, staticRenderFns } from "./BannerWideSkyscraper.vue?vue&type=template&id=3190cc37&scoped=true&lang=pug&"
import script from "./BannerWideSkyscraper.vue?vue&type=script&lang=js&"
export * from "./BannerWideSkyscraper.vue?vue&type=script&lang=js&"
import style0 from "./BannerWideSkyscraper.vue?vue&type=style&index=0&id=3190cc37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190cc37",
  null
  
)

export default component.exports